import { Component, OnInit } from '@angular/core';
import { DwComponent, DwComponentType, DwMetaDataListCardConfigData } from '@devwareapps/devware-cap';

import { AppMetaDataItemNames } from '../../../../../meta-data/app-meta-data.service';

@DwComponent<DwMetaDataListCardConfigData>({
  name: 'Empty State - No Assignments - My Assignments Redesign',
  key: 'noAssignmentsCardMyAssignmentsRedesign',
  componentType: DwComponentType.card,
  isGlobal: false,
  parentItemName: AppMetaDataItemNames.Assignment,
  configData: {
  }
})
@Component({
  selector: 'app-assignment-blank-card-my-assignments-redesign',
  templateUrl: './assignment-blank-card-my-assignments-redesign.component.html',
  styleUrls: ['./assignment-blank-card-my-assignments-redesign.component.scss']
})
export class AssignmentBlankCardMyAssignmentsRedesignComponent implements OnInit {
  constructor() { }

  ngOnInit(): void {
  }
}
